
const defaultQuery = 'artificial intelligence';

export const getSearchQuery = () => {
  if (typeof window === 'undefined') return defaultQuery;
  return localStorage.getItem('newsSearchQuery') || defaultQuery;
};

export const setSearchQuery = (query: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('newsSearchQuery', query);
  }
};

export const NEWS_SEARCH_QUERY = getSearchQuery();
